import type { ReactNode } from "react";

import {
  Pressable,
  type PressableProps,
  type StyleProp,
  StyleSheet,
  type ViewStyle,
} from "react-native";

import { GBlurView } from "@/components/GBlurView";

interface GPressableProps extends Omit<PressableProps, "children" | "style"> {
  blurStyle?: StyleProp<ViewStyle>;
  children?: ReactNode;
  style?: StyleProp<ViewStyle>;
}

export function GPressable({
  blurStyle,
  children,
  style,
  ...rest
}: GPressableProps) {
  return (
    <Pressable style={style} {...rest}>
      <GBlurView style={[styles.base, blurStyle]}>{children}</GBlurView>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  base: {
    borderRadius: 16,
    paddingHorizontal: 14,
    paddingVertical: 6,
  },
});
